import * as React from 'react';

export type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'p'
  | 'lead'
  | 'large'
  | 'small'
  | 'muted'
  | 'blockquote'
  | 'code'
  | 'pre'
  | 'ul'
  | 'ol'
  | 'li'
  | 'strong'
  | 'em'
  | 'mark'
  | 'del'
  | 'ins'
  | 'sub'
  | 'sup'
  | 'kbd'
  | 'table'
  | 'thead'
  | 'tbody'
  | 'tfoot'
  | 'tr'
  | 'th'
  | 'td';

export type TypographyColor =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'muted'
  | 'danger'
  | 'warning'
  | 'success'
  | 'info';

export type TypographyAlign =
  | 'default'
  | 'left'
  | 'center'
  | 'right'
  | 'justify';

export type TypographyWeight =
  | 'default'
  | 'thin'
  | 'extralight'
  | 'light'
  | 'normal'
  | 'medium'
  | 'semibold'
  | 'bold'
  | 'extrabold'
  | 'black';

export type TypographySize =
  | 'default'
  | 'xs'
  | 'sm'
  | 'base'
  | 'lg'
  | 'xl'
  | '2xl'
  | '3xl'
  | '4xl'
  | '5xl'
  | '6xl'
  | '7xl'
  | '8xl'
  | '9xl';

// Mapping of variants to their default HTML elements
export const variantElementMap: Record<
  TypographyVariant,
  keyof React.JSX.IntrinsicElements
> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  p: 'p',
  blockquote: 'blockquote',
  code: 'code',
  pre: 'pre',
  ul: 'ul',
  ol: 'ol',
  li: 'li',
  strong: 'strong',
  em: 'em',
  mark: 'mark',
  del: 'del',
  ins: 'ins',
  sub: 'sub',
  sup: 'sup',
  kbd: 'kbd',
  table: 'table',
  thead: 'thead',
  tbody: 'tbody',
  tfoot: 'tfoot',
  tr: 'tr',
  th: 'th',
  td: 'td',
  // Text variants that map to semantic elements
  lead: 'p',
  large: 'p',
  small: 'p',
  muted: 'p',
};
